export const PIPELINE_PAGE = 'pipeline';
export const LEAD_PAGE = 'lead';

export type PageContext = 'pipeline' | 'lead';
